__turbopack_context__.v({
  "Avatar": "_4AfZOq_Avatar",
  "Fallback": "_4AfZOq_Fallback",
  "Image": "_4AfZOq_Image",
  "autoLink": "_4AfZOq_autoLink",
  "col": "_4AfZOq_col",
  "footer": "_4AfZOq_footer",
  "inline": "_4AfZOq_inline",
  "itemRoot": "_4AfZOq_itemRoot",
  "menuWrapper": "_4AfZOq_menuWrapper",
  "mob": "_4AfZOq_mob",
  "name": "_4AfZOq_name",
  "position": "_4AfZOq_position",
  "postContent": "_4AfZOq_postContent",
  "repliesWrapper": "_4AfZOq_repliesWrapper",
  "reply": "_4AfZOq_reply",
  "replyBtn": "_4AfZOq_replyBtn",
  "sub": "_4AfZOq_sub",
  "subItem": "_4AfZOq_subItem",
  "time": "_4AfZOq_time",
});
